<template>
  <v-menu v-model="mostrar" :close-on-content-click="false" offset-y left>
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :value="totalFiltrosActivos > 0"
        :content="totalFiltrosActivos"
        color="secondary"
        overlap
        bordered>
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-filter-variant</v-icon>
        </v-btn>
      </v-badge>
    </template>
    <v-card width="360px">
      <v-card-title>Más Filtros</v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <custom-text-field
            label="Buscar número, objeto o contratista..."
            append-icon="mdi-magnify"
            class="my-1"
            :value="filtros.buscarTexto"
            clearable
            @keyup="buscar"
            @click:clear="limpiarBuscadorTexto">
          </custom-text-field>
          <v-col cols="12" class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.contratista"
            label="Contratista"
            item-value="id"
            item-text="nombreRazonSocial"
            class="my-1"
            clearable
            :items="getContratistas">
          </custom-select>
          <custom-select
            v-model="filtros.responsable"
            label="Responsable"
            item-value="id"
            item-text="nombre"
            class="my-1"
            clearable
            :items="getResponsables">
          </custom-select>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'TableroExpedientesFiltrosSecundarios',
  props: {
    filtros: {
      type: Object,
      required: true,
    },
    datosCompletos: {
      type: Array,
      required: true,
    },
  },
  components: {
    CustomSelect,
    CustomTextField,
  },
  data() {
    return {
      mostrar: false,
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 500);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
  },
  computed: {
    totalFiltrosActivos() {
      return [
        this.filtros.buscarTexto,
        this.filtros.contratista,
        this.filtros.responsable,
      ].filter((valor) => !!valor).length;
    },
    getContratistas() {
      return this.$removerDumplicadosArrayObj(
        this.datosCompletos.map(({ contratista }) => contratista),
        'id',
      ).sort((a, b) => a.nombreRazonSocial.localeCompare(b.nombreRazonSocial));
    },
    getResponsables() {
      const responsables = this.datosCompletos
        .flatMap(({ responsables: listaResponsables }) => listaResponsables)
        .filter((responsable) => responsable.principal)
        .map(({ funcionario }) => funcionario);
      return this.$removerDumplicadosArrayObj(responsables, 'id')
        .sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
  },
};
</script>

<style lang="scss">
</style>
